export default __webpack_public_path__ + "static/media/electricity.dc4264d3.svg";